import { ResourceModel } from "src/app/core/models/resource.model";

export class Ec2 extends ResourceModel<Ec2> {
    state!: string
    name!: string
    application!: string
    instanceId!: string
    instanceType!: string
    region!: string
    launchTime!: Date
    stateChangedAt?: string
}